// extracted by mini-css-extract-plugin
export default {"recentLessonCards":"RecentLessonCards_recentLessonCards__+QqMy"};